import { VersionResponseModel } from './../../models/versionModel/version-response-model';
import { VersionDefaultResponseModel } from './../../models/versionModel/VersionDefaultResponseModel';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private base = environment.urlServerApi+'version';
  
  constructor(private _http: HttpClient) {
  }

  getVersionsMeeting(meetingId:number) : Observable<VersionResponseModel>{
    return this._http.get<VersionResponseModel>(`${this.base}/meeting?meetingId=${meetingId}`)
  }

  saveTranscriptionVersion(meetingId: number, userEditor: string){
    return this._http.post<VersionDefaultResponseModel>(`${this.base}/new/?meetingId=${meetingId}&userEditor=${userEditor}`,{})
  }
}
